<article class="article">
  <main>
    <div class="content">
      <div class="accounts-header">
        <h2 class="accounts-title">Accounts</h2>
        <button
          matButton="outlined"
          class="primary-button"
          [disabled]="!hasInviteRole"
          (click)="inviteSubAccount()">
          <mat-icon>add</mat-icon>
          Add sub-account
        </button>
      </div>

      <mat-divider></mat-divider>

      <div class="accounts-current-company">
        <h4 class="accounts-sub-title gray-default">Virtual premium access</h4>
        <div class="accounts-company-content">
          <div>
            <ume-flag
              [code]="currentCompany.country?.code || currentCompany.countryCode"></ume-flag>
            <span class="ellipsis dark-grey">{{ currentCompany.companyName }}</span>
          </div>
        </div>
        <button
          matButton
          class="primary-button"
          (click)="goToEditDetails()">
          <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
          <span>Edit entity details</span>
        </button>
      </div>

      <mat-divider></mat-divider>

      <div class="accounts-main-content">
        <div class="flex align-center expand">
          <h4 class="accounts-sub-title gray-default">Sub-accounts</h4>
        </div>

        <div class="table-wrap">
          <table
            cdk-table
            class="mat-table table"
            [dataSource]="dataSource">
            <!-- Name Column -->
            <ng-container cdkColumnDef="name">
              <th
                cdk-header-cell
                *cdkHeaderCellDef>
                Entity
              </th>
              <td
                cdk-cell
                *cdkCellDef="let element">
                <ume-company-link
                  [company]="element.companyInfo"
                  [brId]="element.brGuid"></ume-company-link>
              </td>
            </ng-container>

            <!-- Address Column -->
            <ng-container cdkColumnDef="address">
              <th
                cdk-header-cell
                *cdkHeaderCellDef>
                Registered address
              </th>
              <td
                cdk-cell
                *cdkCellDef="let element">
                @if (element?.companyInfo?.googleAddress) {
                  <a
                    [href]="
                      'https://maps.google.com?q=' +
                      element.companyInfo.googleAddress.geometry.location.lat +
                      ',' +
                      element.companyInfo.googleAddress.geometry.location.lng
                    "
                    target="_blank">
                    {{ element.companyInfo.googleAddress.formatted_address }}
                  </a>
                } @else {
                  <span class="ellipsis">{{ element.streeAddress }}</span>
                }
              </td>
            </ng-container>

            <!--  Status column  -->
            <ng-container cdkColumnDef="status">
              <th
                cdk-header-cell
                *cdkHeaderCellDef
                class="status">
                <span>Status</span>
              </th>
              <td
                cdk-cell
                *cdkCellDef="let element"
                class="status text-left">
                <ume-oversight-sub-status
                  [br]="element.brGuid"
                  [placement]="popPlacements.LEFTSTART"
                  [oversightStatus]="element.brStatus ?? null"></ume-oversight-sub-status>
              </td>
            </ng-container>

            <!--Manage SA options column-->
            <ng-container cdkColumnDef="manageOptions">
              <th
                cdk-header-cell
                *cdkHeaderCellDef>
                <div class="flex align-center">
                  <span>Counterparty management</span>
                  <mat-icon
                    matTooltip="Allow sub-account to invite counterparties and manage requests."
                    class="mat-icon-sm"
                    [fontSet]="'material-symbols-outlined'">
                    info
                  </mat-icon>
                </div>
              </th>
              <td
                cdk-cell
                *cdkCellDef="let element">
                <mat-slide-toggle
                  class="primary-button"
                  [disabled]="element.brStatus !== oversightStatus.DDQ_SHARED"
                  [checked]="element.counterpartyManagementEnabled"
                  (change)="toggleManageOptions(element.brGuid, $event.checked)"
                  (keydown)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  aria-label="Toggle counterparty management for this sub-account"
                  [matTooltip]="
                    element.counterpartyManagementEnabled
                      ? 'This sub-account can invite counterparties and manage requests.'
                      : 'This sub-account cannot invite counterparties or manage requests.'
                  "></mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Selected for assessment Column -->
            <ng-container cdkColumnDef="selectedForAssessment">
              <th
                cdk-header-cell
                *cdkHeaderCellDef></th>
              <td
                cdk-cell
                *cdkCellDef="let row">
                @if (row.assessmentInfo) {
                  @switch (row.assessmentInfo.selectedForAssessment) {
                    @case (selectAssessmentOption.SELECTED) {
                      <div
                        class="flex align-center cursor-pointer"
                        [ngClass]="{ 'cursor-pointer': row.brGuid }"
                        [floatUi]="selectedForAssessments"
                        [showTrigger]="popTriggers.click"
                        [placement]="popPlacements.LEFT"
                        [hideOnMouseLeave]="false"
                        [hideOnClickOutside]="true"
                        [hideOnScroll]="true"
                        [appendTo]="'body'"
                        [showDelay]="200"
                        [disabled]="!row.brGuid"
                        (onShown)="showPopover(row.brGuid)"
                        (onHidden)="hidePopover()">
                        @if (row.nroEnabledForAssessmentSA !== 0) {
                          <span class="counter">
                            <mat-icon class="accent-icon">check</mat-icon>
                            {{ row.nroEnabledForAssessmentSA }} of
                            {{ row.subAccountsCount }}
                          </span>
                        }
                      </div>
                    }
                    @default {
                      <ume-selected-for-assessment
                        [subAccountCount]="row.subAccountsCount"
                        [assessmentInfo]="row.assessmentInfo"
                        [companyName]="row.companyInfo.companyName"
                        [brId]="row.brGuid"
                        (selectedForAssessmentChanged)="
                          selectedForAssessmentChanged($event, row)
                        "></ume-selected-for-assessment>
                    }
                  }
                }
              </td>
            </ng-container>

            <!-- Action Column -->
            <ng-container cdkColumnDef="actions">
              <th
                cdk-header-cell
                *cdkHeaderCellDef>
                <div class="flex align-center">
                  <mat-icon
                    class="mat-icon-xs"
                    fontSet="material-symbols-outlined">
                    edit
                  </mat-icon>
                  <span>Manage assessment</span>
                </div>
              </th>
              <td
                cdk-cell
                class="centred"
                *cdkCellDef="let element">
                <div
                  class="flex expand-center"
                  [matTooltip]="getEnableTooltip(element)">
                  <button
                    matIconButton
                    aria-label="Enable assessment"
                    [disabled]="isEnableAssessmentBtnDisabled(element)"
                    (click)="enableForAssessment(element)">
                    <mat-icon
                      [ngClass]="
                        isEnableAssessmentBtnDisabled(element) ? 'gray-default' : 'primary-icon'
                      "
                      svgIcon="edit_document"></mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr
              cdk-header-row
              *cdkHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              cdk-row
              *cdkRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
    </div>
  </main>
</article>

<float-ui-content #selectedForAssessments>
  @if (details$ | async; as sa) {
    <div class="selected m-b-half">
      @for (selected of sa['ENABLED']; track selected.brGuid; let f = $first) {
        @if (f) {
          <span class="gray-default fs-sm">Enabled for assessment</span>
        }
        <div class="sa-row">
          <ume-flag
            [code]="selected.companyInfo.country.code || selected.companyInfo.countryCode"
            class="m-r-half"></ume-flag>
          <span class="ellipsis dark-grey">{{ selected.companyInfo.companyName }}</span>
        </div>
      }
    </div>

    @for (discarded of sa['DISABLED']; track discarded.brGuid; let f = $first) {
      @if (f) {
        <span class="gray-default fs-sm">Not enabled for assessment</span>
      }
      <div class="sa-row">
        <ume-flag
          [code]="
            discarded.companyInfo.country.code || discarded.companyInfo.countryCode
          "></ume-flag>
        <span class="ellipsis dark-grey">{{ discarded.companyInfo.companyName }}</span>
      </div>
    }
  }
</float-ui-content>
